import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const lang = localStorage.getItem('lang') || 'en';

export const createBiller = async (billerData) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/biller/create`, billerData);
    return response.data;
  } catch (error) {
    console.error("Create Biller API Error:", error);
    throw error.response?.data || { message: "Failed to create biller" };
  }
};

//get all billers
export const getAllBillers = async () => {
  try {
    const lang = localStorage.getItem("lang") || "en";
    const response = await api.get(`${API_BASE_URL}api/biller/list`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": lang
      }
    });
    return response.data;
  } catch (error) {
    console.error("Get Billers API Error:", error);
    throw error.response?.data || { message: "Failed to fetch billers" };
  }
};

// Update a biller
export const updateBiller = async (id, billerData) => {
  try {
    const response = await api.put(`${API_BASE_URL}api/biller/update/${id}`, billerData, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      }
    });
    return response.data;
  } catch (error) {
    console.error("Update Biller API Error:", error);
    throw error.response?.data || { message: "Failed to update biller" };
  }
};

// Delete a biller
export const deleteBillerApi = async (id) => {
  try {
    const response = await api.delete(`${API_BASE_URL}api/biller/delete/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete biller");
  }
};








